<button
    #trigger
    qpxButton
    size="sm"
    matButton="outlined"
    aria-haspopup="dialog"
    [attr.aria-expanded]="opened()"
    (click)="open()"
>
    <ng-icon qpx matButtonIcon name="lucideBuilding2" />
    @let current = selection();
    <span class="max-w-56 truncate">
        @if (current.kind === 'building') {
            {{ current.building | qpxBuildingName }}
        } @else {
            All buildings
        }
    </span>
    <ng-icon qpx matButtonIcon iconPositionEnd name="lucideChevronDown" />
</button>
